import React from "react";
import popupsyle from "../../style/PopUp.module.css";
import workSpace from "../../style/components/bars/WorkSpace.module.css";
import {
  getCompanyDetails,
  getSelectedCompany,
  storeSelectedCompany,
} from "../../utils/auth";

const WorkSpace = ({ show, close, companyUpdated }) => {
  // const company = useCompanySwitch();
  const selectedCompany = getSelectedCompany() || [];
  const apiUrl = process.env.REACT_APP_API_URL;
  const company = getCompanyDetails() || {};
  const companies = Array.isArray(company) ? company : [];
  const viewCompany = companies.filter(
    (comp) => comp.id !== selectedCompany.id
  );
  // const viewCompany = company?.filter((comp) => comp.id !== selectedCompany.id);
  const handleUpdateCompany = (company) => {
    companyUpdated(company);
    storeSelectedCompany(company);
    close();
    localStorage.removeItem("selectedperson");
    localStorage.removeItem("seleteddms");
    localStorage.removeItem("seletedactivity");

    // console.log(company)
  };

  if (!show) return null;
  return (
    <div
      className={popupsyle.popupBackgroundNormal}
      onClick={(e) => e.target === e.currentTarget && close()}
    >
      <div className={workSpace.workSpaceContainer}>
        <div className={workSpace.WorkSpaceOverFlow}>
          <div className={workSpace.workSpaceContainersb}>
            <div className={workSpace.workSpaceSelectedCompany}>
              <h3>{selectedCompany.company_name}</h3>
              <p className={workSpace.workspaceSelectedemail}>
                {selectedCompany.company_email}
              </p>
            </div>
            <span className={workSpace.lineSeparator}></span>
            {viewCompany.length > 0 ? (
              viewCompany?.map((comp) => (
                <div
                  key={comp.id}
                  className={workSpace.WorkSpaceViewComp}
                  onClick={() => handleUpdateCompany(comp)}
                >
                  <div className={workSpace.WorkSpaceCompViewimg}>
                    <img alt="img" src={`${apiUrl}${comp.company_logo}`} />
                  </div>
                  <div className={workSpace.WorkSpaceMailNam}>
                    <h3>{comp.company_name}</h3>
                    <p className={workSpace.workspaceSelectedemail}>
                      {comp.company_email}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", padding: "1rem" }}>
                <p>No other companies available to switch.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkSpace;
